import { render, staticRenderFns } from "./ArtLanding.vue?vue&type=template&id=776cf643&"
import script from "./ArtLanding.vue?vue&type=script&lang=js&"
export * from "./ArtLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports